import React from "react";

export default function Bubbles() {
  return (
    <div aria-hidden="true" className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="blob blob-1" />
      <div className="blob blob-2" />
    </div>
  );
}
